import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/logo.png'
import _imports_1 from '../assets/image/avatar.png'
import _imports_2 from '../assets/image/lange2.png'
import _imports_3 from '../assets/image/lange3.png'


const _withScopeId = n => (_pushScopeId("data-v-d96086bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aside-name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "images",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_2 = { class: "user-panel hidden-xs" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pull-left image" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "addtabsit" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "img-circle"
    })
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "pull-left info"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "header-lf" }
const _hoisted_7 = { class: "language" }
const _hoisted_8 = { class: "d_down el-dropdown-link" }
const _hoisted_9 = {
  key: 0,
  src: _imports_2
}
const _hoisted_10 = {
  key: 1,
  src: _imports_3
}
const _hoisted_11 = { class: "col_title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trigger-min" }, null, -1))
const _hoisted_13 = { class: "header-fhs" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "logo flx-center" }
const _hoisted_16 = { class: "logo-name" }
const _hoisted_17 = { class: "secondnav" }
const _hoisted_18 = { class: "t_news" }
const _hoisted_19 = { class: "asdsa" }
const _hoisted_20 = { class: "content-box" }

import {
  reactive,
  onMounted,
  computed,
  ref,
  watch,
  defineComponent,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import { ArrowRight, ArrowLeft, ArrowDown } from "@element-plus/icons-vue";
import screenfull from "screenfull";
import { Sunny, Moon } from "@element-plus/icons-vue";
import { useDark } from "@vueuse/core";
import api from "@/request/api";
import En from "@/components/En.vue";
import { useI18n } from "vue-i18n";
import { generateTitle } from "@/utils/i18n";
import watermark from "../utils/watermark";
import { useThrottle } from "@/utils/useThrottle";
import Detail from "@/components/detail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

onMounted(() => {
  selectListdata();
});

const { locale } = useI18n();

const isCollapse = ref(false);
let pc = sessionStorage.getItem("pc");
if (pc === "2") {
  isCollapse.value = true;
}

const closeSide = (item: any) => {
  if (pc === "2") {
    isCollapse.value = true;
  }
};
const router = useRouter();

let nickname: any = sessionStorage.getItem("nickname");
/// 水印
watermark.set(nickname);

const menuList = router.getRoutes().filter((v) => v.meta.isShow);
///过滤页面权限
let auth: string[] = [];
let a: any = sessionStorage.getItem("auth");
if (a != null) {
  auth = a.split(",");
} else {
  auth = [];
}
// 递归过滤路由
function filterMenuList(menuList: any[], auth: string[]): any[] {
  return menuList.filter((item) => {
    // 检查当前路由的 path 是否在 auth 中
    const isValid = auth.includes(item.path);
    // 如果有子路由，则需要递归检查
    if (item.children && item.children.length > 0) {
      item.children = item.children.filter((child: { path: string }) =>
        auth.includes(child.path)
      ); // 过滤子路由
    }
    // 如果当前路由有效或者有有效的子路由，则保留
    return isValid || (item.children && item.children.length > 0);
  });
}

// 过滤后的菜单
let filteredMenuList = filterMenuList(menuList, auth);
//退出登录
const logout = useThrottle(() => {
  let username: any = {
    username: sessionStorage.getItem("username"),
  };
  api.post("user/logout", username).then((res: any) => {
    // 清除 Token
    sessionStorage.clear();
    // 重定向到登陆页
    router.push("/login");
    router.go(0);
    ElMessage.success("退出登录成功！");
  });
}, 1000);

const fullscreenElement = ref(null); // 用于保存全屏显示的元素
// 切换全屏状态的方法
const toggleFullscreen = () => {
  if (screenfull.isEnabled) {
    const elem = fullscreenElement.value as unknown as Element;
    screenfull.toggle(elem);
  } else {
  }
};
// 2. 使用useDark
const isDark = useDark();
// 3. 主题配置
const themeConfig = reactive({
  isDark: isDark,
});

const changebgcolor = (value: any) => {
  // true 暗色  false 白色
  if (value) {
    sessionStorage.setItem("bgcolor", "white");
  } else {
    sessionStorage.setItem("bgcolor", "black");
  }
};

// 语言切换
let languageShow = ref(sessionStorage.getItem("langShow") || "en");
const langOptions = [
  { label: "English", value: "en" },
  { label: "Italiano", value: "it" },
  { label: "中文", value: "zhCn" },
];
const changeLang = (val: any) => {
  languageShow.value = val;
  locale.value = val;
  sessionStorage.setItem("lang", locale.value);
  sessionStorage.setItem("langShow", languageShow.value);
  router.go(0);
};

// 当前语言显示文字
const currentLangLabel = computed(() => {
  const found = langOptions.find((item) => item.value === languageShow.value);
  return found ? found.label : "English";
});
// 系统通知列表数据
let SystemData = ref();
let autoplay = ref(false);
// 通知列表
const selectListdata = async () => {
  try {
    const response = await api.get(
      `notice/list?page=${1}&pageSize=${100}&type=${"系统通知"}`
    );
    SystemData.value = response.data.list;
    if (SystemData.value.length > 0) {
      autoplay.value = true;
    }
  } catch (error) {}
};

let dialogVisible = ref(false);
let code = ref(0);
const openDetail = (item: any) => {
  dialogVisible.value = !dialogVisible.value;
  code.value = item.id;
};
const closeD = (val: any) => {
  dialogVisible.value = val.value;
};

return (_ctx: any,_cache: any) => {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: "common-layout",
    ref_key: "fullscreenElement",
    ref: fullscreenElement
  }, [
    _createVNode(_unref(watermark), { text: _unref(nickname) }, null, 8, ["text"]),
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          class: _normalizeClass({ collapsed: isCollapse.value }),
          style: _normalizeStyle(themeConfig.isDark ? '' : 'background-color: #fff;')
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (isCollapse.value === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(nickname)), 1),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_SuccessFilled)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("login.online")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_menu, {
              "active-text-color": "#409eff",
              class: "el-menu-vertical-demo",
              router: "",
              collapse: isCollapse.value,
              "collapse-transition": false,
              "default-active": _ctx.$route.path,
              onSelect: closeSide
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredMenuList), (subItem) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: subItem.path
                  }, [
                    (subItem.children?.length)
                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          index: subItem.path,
                          key: subItem.path,
                          class: _normalizeClass({ collapsed: isCollapse.value })
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.meta.icon)))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(En, {
                              title: _unref(generateTitle)(subItem.meta.title)
                            }, null, 8, ["title"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.children, (item) => {
                              return (_openBlock(), _createBlock(_component_el_menu_item, {
                                key: item.path,
                                index: item.path,
                                class: _normalizeClass({ collapsed: isCollapse.value })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(En, {
                                    title: _unref(generateTitle)(item.meta.title)
                                  }, null, 8, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["index", "class"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["index", "class"]))
                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 1,
                          class: _normalizeClass({ collapsed: isCollapse.value }),
                          index: subItem.path
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.meta.icon)))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(En, {
                              title: _unref(generateTitle)(subItem.meta.title)
                            }, null, 8, ["title"])
                          ]),
                          _: 2
                        }, 1032, ["class", "index"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["collapse", "default-active"])
          ]),
          _: 1
        }, 8, ["class", "style"]),
        _createVNode(_component_el_container, { class: "app" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "heds",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapse.value = !isCollapse.value))
                }, [
                  (isCollapse.value)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Expand)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Fold)
                        ]),
                        _: 1
                      }))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_dropdown, { onCommand: changeLang }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langOptions, (item) => {
                              return _createVNode(_component_el_dropdown_item, {
                                key: item.value,
                                command: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["command"])
                            }), 64))
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          (_unref(pc) == '1')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(currentLangLabel)), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_12,
                  _createVNode(_component_el_popover, {
                    ref: "popoverRef",
                    trigger: "click"
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(nickname)), 1)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "dasd",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(logout) && _unref(logout)(...args)))
                      }, [
                        _createVNode(_component_el_icon, { class: "icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_SwitchButton)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("routers.logOut")), 1)
                      ])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_carousel, {
                  direction: "vertical",
                  interval: 2000,
                  autoplay: _unref(autoplay)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SystemData), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_carousel_item, {
                        key: item.id,
                        onClick: ($event: any) => (openDetail(item))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("login.system")), 1),
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["autoplay"])
              ])
            ]),
            _createVNode(_component_el_main, {
              style: _normalizeStyle(_unref(pc) === '1' ? '' : 'padding: 0;')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Detail, {
      dialogVisible: _unref(dialogVisible),
      code: _unref(code),
      onCloseD: closeD
    }, null, 8, ["dialogVisible", "code"])
  ], 512))
}
}

})